import { AddressFields } from "../../Address/AddressFields";
import { AddressSearch } from "../../Address/AddressSearch";
import { AddreesFieldsManual } from "../../Address/AddreesFieldsManual";
import { useForm } from "react-hook-form";
import { useAddressComponent, useSubmitAddressChange } from "./hooks";
import type { IErrors } from "../../Address/types";
import { useState } from "react";

interface AddressModalProps {
  handleClose(): void;
}

export function AddressModal(props: AddressModalProps) {
  const { handleClose } = props;
  const [errors, setErrors] = useState<IErrors>({});
  const { register, handleSubmit, setValue } = useForm({
    mode: "onBlur",
  });

  const {
    manual,
    updateFullAddress,
    loaclError,
    pickSuggestion,
    validateAddress,
    setLocalError,
    suggestions,
    setSuggestions,
    fullAddress,
    setFullAddress,
    address_fields,
  } = useAddressComponent({ setValue, errors, setErrors });

  const { setUpdatedAddress } = useSubmitAddressChange({
    errors,
    setErrors,
    handleClose,
  });
  return (
    <form
      onSubmit={(e: any) => {
        e.preventDefault();
        handleSubmit(setUpdatedAddress)(e);
      }}
    >
      {fullAddress ? (
        <AddressFields
          updateFullAddress={updateFullAddress}
          setFullAddress={setFullAddress}
          fullAddress={fullAddress}
          errors={errors}
          setErrors={setErrors}
          register={register}
          handleClose={handleClose}
        />
      ) : (
        <AddressSearch
          suggestions={suggestions}
          setSuggestions={setSuggestions}
          validateAddress={validateAddress}
          pickSuggestion={pickSuggestion}
          setLocalError={setLocalError}
          errors={errors}
          setErrors={setErrors}
          loaclError={loaclError}
          handleClose={handleClose}
        />
      )}

      {manual ? (
        <AddreesFieldsManual
          register={register}
          fullAddress={fullAddress}
          address_fields={address_fields}
          errors={errors}
          handleClose={handleClose}
        />
      ) : null}
    </form>
  );
}
